export default [
    {
        key: 1,
        type: 'active',
        order: {
            number: '122 352 180 419 000 02',
            date_create: 1562176730599
        },
        view: 'ОПГД',
        state: {
            type: 'tobook',
            accepted: false,
            check: null
        },
        passengers: 52,
        date_of_application: 1561076730599,
        place_of_supply: {
            street: 'ул Сергея Макеева, 15',
            city: 'г Москва'
        }
    },{
        key: 2,
        type: 'active',
        order: {
            number: '123 352 180 419 000 02',
            date_create: 1562276730599,
        },
        view: 'ТТ',
        state: {
            type: 'tobook',
            accepted: true,
            check: null
        },
        passengers: 35,
        date_of_application: 1561076730599,
        place_of_supply: {
            street: 'ш Энтузиастов, 2А',
            city: 'г Москва'
        }
    },{
        key: 3,
        type: 'active',
        order: {
            number: '213 352 260 419 000 35',
            date_create: 1562376730599
        },
        view: 'ПНКЛ',
        state: {
            type: 'ready',
            accepted: null,
            check: null
        },
        passengers: 0,
        date_of_application: 1561076730599,
        place_of_supply: {
            street: 'ул Днепропетровская, 27',
            city: 'г Москва'
        }
    },{
        key: 4,
        type: 'active',
        order: {
            number: '212 352 270 419 000 21',
            date_create: 1562446730599
        },
        view: 'ОПГД',
        state: {
            type: 'tobook',
            accepted: null,
            check: false
        },
        passengers: 24,
        date_of_application: 1561076730599,
        place_of_supply: {
            street: 'ул Широкая, 12',
            city: 'г Москва'
        }
    }
]